import React from "react";
import ManageBlog from "../../components/ManageBlog";
import saveToApm from "../../apm";
import { useEffect} from "react";

const ManageBlogMainComponent = () => {
    useEffect(() => {
        saveToApm("Manage blogs (/ManageBlog)");
    }, []);
  return (
    <div>
      <ManageBlog />
    </div>
  );
};

export default ManageBlogMainComponent;
